export default __webpack_public_path__ + "maps-examples-building-extrusions-thumbnail-960-6b448c24eab4f804a2703c4c93fad853.png";